/**
 * ChainContext context instance and type definition.
 * Separated from ChainContext.tsx so hooks can live in their own file
 * without triggering react-refresh/only-export-components warnings.
 */

import { createContext } from 'react';
import type { Chain } from 'types';

export interface ChainContextType {
  // Chain data from API
  chains: Chain[];
  enabledChains: Chain[];
  isLoadingChains: boolean;
  chainsError: Error | null;

  // Selected chain state
  selectedChain: Chain | null;
  selectedChainId: number | null;
  setSelectedChain: (chain: Chain) => void;
  setSelectedChainById: (chainId: number) => void;

  // Helper functions
  getChainById: (chainId: number) => Chain | undefined;
  getChainByName: (name: string) => Chain | undefined;
  getLockerAddress: () => string | undefined;
  getExplorerUrl: () => string | undefined;
  getExplorerTxUrl: (txHash: string) => string;
  getExplorerAddressUrl: (address: string) => string;

  // Status
  isChainSelected: boolean;
  isSelectedChainEnabled: boolean;
}

export const ChainContext = createContext<ChainContextType | null>(null);
